export default "__VITE_ASSET__CjrQs$$X__"